function defer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function() { defer(method) }, 50);
    }
}

const updateProperty = function() {
  $('.upcart-item-property strong').each(function(curr) {
    $(this).html($(this).html().replace(/_/g, " "));
  });
}

defer(function () {
  // Manage Engrave Option
  let productEngraveOption = document.getElementById('customize');
  if(productEngraveOption) {
    productEngraveOption.addEventListener('change', (event) => {
      if (event.currentTarget.checked) {
        addEngraveFieldToForm();
        if(document.getElementsByClassName('engrave-form')[0]) {
          if(document.getElementsByClassName('engrave-form')[0].classList.contains('hidden-content')) {
            document.getElementsByClassName('engrave-form')[0].classList.remove('hidden-content');
          }
        }
      } else {
        if(!document.getElementsByClassName('engrave-form')[0].classList.contains('hidden-content')) {
            document.getElementsByClassName('engrave-form')[0].classList.add('hidden-content');
        }
      }
    });
  }
  // ITCoders :: Modify upcart logic
  window.upcartOnAddToCart = function(id, quantity, item) {
    //console.log("Inside the upcart event", item);
    // if($('#customize').is(':checked') && item.vendor == "Benchmark") { // Comment for the enable option for all
    //   // Auto add engrave product to the cart
    //   if(item?.properties?.font_type) {
    //     autoAddEngravingProduct(item.id, item.product_title,item?.properties?.font_type??'SCRIPT',item?.properties?.engraving_text??'');
    //   }
    //   setTimeout(function() {
    //     updateProperty();
    //   }, 1000)
    // }
    // Auto add engrave product to the cart
    if(item?.properties?.font_type) {
      autoAddEngravingProduct(item.id, item.product_title,item?.properties?.font_type??'SCRIPT',item?.properties?.engraving_text??'');
      setTimeout(function() {
        updateProperty();
      }, 1000);
    }
    
  }
  window.upcartOnCartUpdated = function() {
    updateProperty();
  }
  window.upcartOnCartOpened = function() {
    updateProperty();
  }
  window.upcartOpenCart = function() {
    updateProperty();
  }
  const addEngraveFieldToForm = function() {
    let productFormSelector = $('form[action="/cart/add"]');
    if(productFormSelector.length > 0) {
      let inputName = "properties[font_type]";
      
      if(productFormSelector.find('input[name="'+inputName+'"]').length == 0) {
        // add propery input in the cart form
        var newInputHTML = '<input type="hidden" name="'+inputName+'" value="SCRIPT"/>';
        productFormSelector.append(newInputHTML);
      }
      inputName = "properties[engraving_text]";
      if(productFormSelector.find('input[name="'+inputName+'"]').length == 0) {
        // add propery input in the cart form
        var newInputHTML = '<input type="hidden" name="'+inputName+'" value=""/>';
        productFormSelector.append(newInputHTML);
      }
    } else {
      let inputName = "properties[font_type]";
      
      if(productFormSelector.find('input[name="'+inputName+'"]').length == 1) {
        productFormSelector.find('input[name="'+inputName+'"]').remove();
      }
      inputName = "properties[engraving_text]";
      
      if(productFormSelector.find('input[name="'+inputName+'"]').length == 1) {
        productFormSelector.find('input[name="'+inputName+'"]').remove();
      }
    }
  }
  setTimeout(function() {
    jQuery(function() {
      setTimeout(function() {
        // set font type in cart form
        if($('input[name="properties[engraving_type]"]').length > 0) {
          jQuery('input[name="properties[engraving_type]"]').on('change', function() {
            // set class for the dynamic font-type load
            jQuery('#engraveText').removeClass().addClass($(this).val().toLowerCase() + '-font');
            const productFormSelector = $('form[action="/cart/add"]');
            const inputName = "properties[font_type]";
            
            if(productFormSelector.find('input[name="'+inputName+'"]').length > 0) {
                productFormSelector.find('input[name="'+inputName+'"]').val($(this).val());
            }
          });
        }
        // set font type in cart form as well show the limit of characters
        if($('input[name="properties[engraving]"]').length > 0) {
          $('input[name="properties[engraving]"]').on('keyup', function() {
            $('#countOfCharacter').html(30 - $(this).val().length);
            const productFormSelector = $('form[action="/cart/add"]');
            const inputName = "properties[engraving_text]";
            if(productFormSelector.find('input[name="'+inputName+'"]').length > 0) {
                productFormSelector.find('input[name="'+inputName+'"]').val($(this).val());
            }
          });
        }
      }, 200);
    });
  }, 200);
  
  const autoAddEngravingProduct = async function(pID, pTitle, eType, eText) {
    let currentEngraveType = eType??$('input[name="properties[engraving_type]"]:checked').val();
    let variantID = "46686138663152";
    if(currentEngraveType == 'SCRIPT') {
      variantID = "46686138630384";
    }
    let formData = {
     'items': [{
      'id': variantID,
      'quantity': 1,
       'properties': { 'product_id': pID, 'product_title': pTitle, 'engraving_type': eType, 
                     'engraving_text':eText }
      }]
    };
    return await fetch(window.theme.routes.cartAdd + "?type=engrave", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .catch((error) => {
      console.error('Error:', error);
      return null;
    });
  }
  
  // Manage Extra Product Description
  let proCustomDescSelector = document.querySelectorAll('.benchmark-description .process-desc');
  if(proCustomDescSelector.length > 0){
    proCustomDescSelector.forEach(function (currentEle) {
      let fieldKey = currentEle.getAttribute('data-field');
      let fieldValueJson = currentEle.getAttribute("data-"+fieldKey);
      let fieldValue = fieldValueJson ? JSON.parse(currentEle.getAttribute("data-"+fieldKey)) : [];
      if(fieldKey == 'metaltype') {
        currentEle.classList.remove('inactive');
        currentEle.querySelector('span').innerHTML = fieldValue.join(" / ");
      }
      if(fieldKey == 'gemstone' && fieldValue.length > 0) {
        currentEle.classList.remove('inactive');
        currentEle.querySelector('span').innerHTML = fieldValue[0].type;
      }
    });
  }
});